import React, { useState } from 'react';
import * as Actions from '@/app/store/actions';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import dayjs from 'dayjs';
import { Avatar, IconButton, Menu, MenuItem, Tooltip } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import DeletEventDailog from './DeleteEventConfirmDialog';
import { useNavigate } from 'react-router-dom';

const EventsCard = ({ row, setRefresh, refresh, isEventsLoading, setIsEventsLoading }) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const open = Boolean(anchorEl);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const updateEvent = (row) => {
		navigate(`/calendar-updateevent/${row.id}`);
	};

	const DeleteEvent = (ro) => {
		dispatch(
			Actions.openDialog({
				children: (
					<DeletEventDailog
						isEventsLoading={isEventsLoading}
						refresh={refresh}
						row={ro}
						setAnchorEl={setAnchorEl}
						setIsEventsLoading={setIsEventsLoading}
						setRefresh={setRefresh}
					/>
				),
			})
		);
	};

	const isCustomEvent = row?.type === '39';

	const eventHasPassed = dayjs(row?.datetime).isBefore(dayjs());

	return (
		<div className="event-box" key={row.id}>
			<div className=" flex justify-between ">
				<h5 className="font-extrabold">{dayjs(row?.datetime).format('MMMM DD, YYYY')}</h5>
				<IconButton
					aria-controls="long-menu"
					aria-haspopup="true"
					aria-label="more"
					id="edit-delete-popup"
					onClick={handleClick}
					style={{ marginTop: '-15px' }}
				>
					<MoreHorizIcon />
				</IconButton>
				<Menu
					MenuListProps={{
						'aria-labelledby': 'long-button',
					}}
					anchorEl={anchorEl}
					id="long-menu"
					onClose={handleClose}
					open={open}
				>
					{!eventHasPassed ? (
						<MenuItem onClick={() => updateEvent(row)}>
							<em id="edit-event">Edit</em>
						</MenuItem>
					) : null}
					<MenuItem onClick={() => DeleteEvent(row)}>
						<em id="delete-event">Delete</em>
					</MenuItem>
				</Menu>
			</div>
			<div className="flex justify-between items-center ">
				<h5 className="event_name mr-8 flex truncate max-w-[200px]">
					<p
						style={{
							marginTop: '-20px',
							marginRight: '8px',
							fontWeight: '700',
							fontSize: '30px',
							color: '#FFBC00',
						}}
					>
						{' '}
						.{' '}
					</p>{' '}
					<Tooltip title={isCustomEvent ? row?.custom_type : row?.event_type?.type}>
						<span className="truncate">{isCustomEvent ? row?.custom_type : row?.event_type?.type}</span>
					</Tooltip>
				</h5>
				<Avatar src={row?.event_type?.icon_url} />
			</div>
			<h5 className="flex event-description">
				{row?.description ? (
					<Tooltip
						arrow
						title={`${row?.student?.first_name ? row?.student?.first_name : ''} ${
							row?.student?.last_name ? row?.student?.last_name : ''
						} ${row?.description ? row?.description : ''}`}
					>
						<span>
							{`${row?.student?.first_name ? row?.student?.first_name : ''} ${
								row?.student?.last_name ? row?.student?.last_name : ''
							} ${row?.description?.slice(0, 10) ? row?.description?.slice(0, 10) : ''} .....`}
						</span>
					</Tooltip>
				) : (
					<span>{`${row?.student?.first_name ? row?.student?.first_name : ''} ${
						row?.student?.last_name ? row?.student?.last_name : ''
					} `}</span>
				)}
			</h5>
			<div className="all-rooms">
				<div className="flex items-center" style={{ gap: 5 }}>
					{/* <AvatarGroup max={4}>
						{row.rooms.map((room, i) => (
							<>{<Avatar key={i} className="room-icon" src={room?.photo} />}</>
						))}
					</AvatarGroup> */}
					<div className="flex">
						{row.rooms.map((room, index) =>
							index < 4 ? (
								<Avatar
									className="room-icon"
									key={index}
									src={room?.thumb}
									style={{ width: 30, height: 30, marginRight: -5 }}
								/>
							) : (
								''
							)
						)}
					</div>
					<h5 className="room-num">&nbsp;{row.rooms.length > 4 ? `${row.rooms.length - 4} Other Rooms` : null} </h5>
				</div>
			</div>
		</div>
	);
};

export default EventsCard;
